const emailValidation = (value) => {
  if (!value || value == '') return false;

  const regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  const result = regex.test(value);

  // Regex test retuns false if doesn't match - therefore we swap values
  return result;
};

const phoneValidation = (value) => {
  if (!value || value == '') return false;

  const regex = /^\({0,1}((0|\+61|61){1}[0-9]){1}\){0,1}(\ |-){0,1}[0-9]{8}$/;
  const result = regex.test(value);

  // Regex test retuns false if doesn't match - therefore we swap values
  return result;
};

export default { emailValidation, phoneValidation };
